var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitfinex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 35,
    viewBox: "0 0 299 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.8 29.6192C266.4 31.3163 275.2 39.4478 289.011 30.01C299 22.2326 298.749 5.37157 297.791 0.276843C297.456 1.0185 285.867 26.422 264.8 29.6192ZM297.791 0.273503C297.667 0.22339 284.818 -1.52719 272.116 6.65444C264.229 11.7325 263.183 19.1691 263.544 24.1369C282.009 22.0589 297.37 0.858144 297.791 0.273503Z",
    fill: "#97C554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.791 0.273503C297.667 0.22339 284.818 -1.52719 272.116 6.65444C264.229 11.7325 263.183 19.1691 263.544 24.1369C282.009 22.0589 297.37 0.858144 297.791 0.273503Z",
    fill: "#709B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8276 28.6269H6.44211V20.9665H20.8276C24.4223 20.9665 26.2598 22.687 26.2598 24.9153C26.2598 27.0634 24.4624 28.6269 20.8276 28.6269ZM20.3599 16.864H6.44211V10.4129H20.3599C24.1484 10.4129 25.635 11.7492 25.635 13.5799C25.635 15.2503 23.9145 16.864 20.3599 16.864ZM24.0348 18.8183C30.095 18.6212 32.2833 15.6111 32.2833 12.3305C32.2799 8.73243 29.4269 5.76245 22.468 5.76245H0.22821V33.2005H23.1328C28.8389 33.2005 33.1018 30.8185 33.1018 25.697C33.1018 22.0622 30.7164 18.9753 24.0315 18.8183H24.0348ZM40.4415 5.76245V33.2005H46.6654V5.76245H40.4415ZM71.8451 10.9607H85.5424V5.76245H51.9639V10.9607H65.6446V33.2005H71.8585L71.8451 10.9607ZM90.8476 5.76245V33.2005H97.0615V22.5099H111.641V17.9965H97.0615V10.493H120.751V5.76245H90.8476ZM125.786 5.76245V33.2005H132V5.76245H125.786ZM146.556 12.4441L167.168 33.2005H174.204V5.76245H168.067V25.54L148.289 5.76245H140.395V33.2005H146.556V12.4441ZM182.603 5.76245V33.2005H213.004V28.5902H188.817V21.0466H203.316V16.7871H188.817V10.493H213.011V5.76245H182.603ZM254.631 5.76245H246.422L235.949 15.4174L225.549 5.76245H217.224L231.843 19.286L216.679 33.2005H224.887L235.869 23.0779L246.813 33.2005H255.165L239.975 19.2493L254.631 5.76245Z",
    fill: "#DDDDDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 298,
    height: 34.4103,
    fill: "white",
    transform: "translate(0.22821 0.0830688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitfinex);
export default __webpack_public_path__ + "static/media/bitfinex.5e1f68d4984622135e922cde5e8465ab.svg";
export { ForwardRef as ReactComponent };